import { render, staticRenderFns } from "./personalIdentification.vue?vue&type=template&id=e1338b1e&scoped=true&"
import script from "./personalIdentification.vue?vue&type=script&lang=js&"
export * from "./personalIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1338b1e",
  null
  
)

export default component.exports